import React, { useState } from 'react';
import { useForm, SubmitHandler, FieldValues } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { TeamMemberRequest } from '@marageti/z4-sdk/lib/people';
import { useApiClient } from '@marageti/z4-lib';
import { useSnackbar } from 'notistack';
import InviteUserFormView from './invite-user-form-view';
import { ContainerProps } from './types';

const InviteUserFormContainer = ({ open, onClose }: ContainerProps) => {
  const apiClient = useApiClient();
  const { enqueueSnackbar } = useSnackbar();
  const [submissionError, setSubmissionError] = useState<ApiError>();
  const navigate = useNavigate();
  const {
    control,
    handleSubmit,
    formState: { isValid, errors, isSubmitting },
    register,
    reset,
  } = useForm({ mode: 'onChange' });

  const handleCancel = () => {
    reset();
    onClose();
  };

  const onSubmit: SubmitHandler<FieldValues> = (data) => {
    setSubmissionError(undefined);
    const {
      email, givenName, familyName, roles,
    } = data;
    const tM: TeamMemberRequest = {
      email,
      familyName,
      givenName,
      userInfo: [
        {
          roles,
        },
      ],
    };

    return apiClient.peopleClient
      .teamMemberExists(data.email)
      .then((exists) => {
        if (exists) {
          return apiClient.peopleClient.getTeamMember(email);
        }
        return apiClient.peopleClient.postTeamMember(tM);
      })
      .then(() => apiClient.authClient.postUserReset(email))
      .then(handleCancel)
      .then(() => enqueueSnackbar('User invited.', { variant: 'success' }))
      .catch((error: ApiError) => {
        if (error.code === 401) navigate('/logout');
        setSubmissionError(error);
      });
  };

  return (
    <InviteUserFormView
      control={control}
      errors={errors}
      handleSubmit={handleSubmit}
      isSubmitting={isSubmitting}
      isValid={isValid}
      onCancel={handleCancel}
      onSubmit={onSubmit}
      open={open}
      register={register}
      submissionError={submissionError}
    />
  );
};

export default InviteUserFormContainer;
